export default "__VITE_ASSET__Bkg8bJNP__"